import styled from 'styled-components';
export const StyledWrapper = styled.div `
  position: absolute;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.white};
  top: 100%;
  left: 0;
  right: 0;
  box-shadow: 0 2px 6px rgba(${({ theme }) => theme.colors.transparentBlack}, 0.26);
`;
export const StyledSingleDatePicker = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  width: 320px;
  min-width: 320px;
`;
const centered = () => `
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const MonthsAndDaysWrapper = styled.div `
  padding: 0 0.5rem 1rem;
  display: inline-block;
`;
export const MonthsWrapper = styled.div `
  min-width: 288px;
  height: auto;
  margin-top: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  background-color: ${({ theme }) => theme.colors.grey03};
  ul {
    margin: 0;
    padding-left: 1rem;
    background-color: white;
    width: unset;
  }
  & .months,
  .years {
    padding: 2rem 1rem 1.5rem 1rem;
    gap: 0.25rem;
    .TabPanelContainer {
      background-color: ${({ theme }) => theme.colors.grey03};
    }
    display: flex;
    flex-wrap: wrap;
    > button {
      flex-basis: 32.25%;
      height: 2.5rem;
      ${centered}
      min-width: unset;
      border-radius: border-box;
    }
  }

  & .years {
    > button {
      flex-basis: 23.95%;
    }
  }

  & button {
    display: inline-flex;

    span {
      display: flex;
      align-items: center;

      svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }
`;
export const ControlsWrapper = styled.div `
  min-height: 2.5rem;
  display: flex;
  flex-direction: row;
  margin-left: 1rem;

  & > div {
    ${centered}
  }

  & > div:first-child {
    justify-content: flex-start;
    flex-grow: 1;
  }
`;
export const WeeksDayWrapper = styled.div `
  ${centered}
  display: flex;
  gap: 0.25rem;
  margin-top: 1rem;
  padding-top: 0.25rem;
  margin-bottom: 0.5rem;
  label {
    width: 2.5rem;
    ${centered}
  }
`;
export const StyledDateInputWrapper = styled.div `
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 20rem;
  width: 20rem;
  input {
    min-width: 9.5rem;
  }
`;
